/** Where this project lives, for anything that leaves the browser. */
export const PROJECT_URL = 'github.com/gabsalvo/nobody-moves-first';

/**
 * The URL to print on a poster.
 *
 * A poster is made to be posted, so it has to carry an address a stranger can actually
 * open. On a deployed site that is the share link itself, which reproduces the exact run.
 * On a development machine it is not — `http://localhost:5173/#r=…` is useless to
 * everyone but the person who made it — so the poster falls back to the project address.
 */
export function posterUrl(shareLink: string): string {
  try {
    const { hostname } = new URL(shareLink);
    const isLocal =
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '0.0.0.0' ||
      hostname.endsWith('.local');
    return isLocal ? PROJECT_URL : shareLink;
  } catch {
    return PROJECT_URL;
  }
}
